module.exports = __webpack_public_path__ + "img/2.4021e6db.jpg";